import {createStyles} from '@mantine/core';
import classNames from 'classnames';
import React from 'react';

import EntityStore from 'stores/EntityStore';
import Label from 'ui-library/bs/Label';

export function makeWelcomeText(): string {
  const currentUser = EntityStore.currentUser();
  const userName = currentUser?.name;
  const displayName = userName != null ? `, ${userName}` : '';
  return `Welcome to Benchling${displayName}!`;
}

interface InfoSidePanelProps {
  titleText: string;
  bodyText: string;
  variant?: 'default' | 'redesigned';
}

export default function InfoSidePanel(props: InfoSidePanelProps): JSX.Element {
  const {classes} = useStyles();

  if (props.variant === 'redesigned') {
    return (
      <div className={classes.redesignedSidePanel}>
        <div className={classes.redesignedWelcomeText}>{makeWelcomeText()}</div>
        <div className={classes.redesignedHeaderText}>{props.titleText}</div>
        <div className={classes.redesignedBodyText}>{props.bodyText}</div>
      </div>
    );
  }

  return (
    <div className={classes.sidePanel}>
      <Label>{makeWelcomeText()}</Label>
      <div className={classes.headerText}>{props.titleText}</div>
      <div className={classNames(classes.bodyText, 'u-faded')}>{props.bodyText}</div>
    </div>
  );
}

const useStyles = createStyles((theme) => ({
  sidePanel: {
    paddingTop: '83px',
  },
  headerText: {
    fontSize: '34px',
    lineHeight: '40px',
    marginTop: '15px',
  },
  bodyText: {
    fontSize: '18px',
    lineHeight: '24px',
    marginTop: '12px',
  },
  redesignedSidePanel: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: '10px',
  },
  redesignedWelcomeText: {
    color: theme.colors.gray[9],
    fontFamily: theme.fontFamily,
    fontSize: '14px',
    fontWeight: theme.other.fontWeights.semibold,
    lineHeight: theme.lineHeight,
  },
  redesignedHeaderText: {
    color: theme.colors.gray[9],
    fontFamily: theme.fontFamily,
    fontSize: '32px',
    fontWeight: theme.other.fontWeights.bold,
    lineHeight: 1.25,
    marginTop: theme.spacing.lg,
    textWrap: 'pretty',
  },
  redesignedBodyText: {
    color: theme.colors.gray[6],
    fontFamily: theme.fontFamily,
    fontSize: '16px',
    lineHeight: 1.6,
    marginTop: '28px',
    textWrap: 'pretty',
  },
}));
